export const DEFAULT_PARTY_CATALOG = Object.freeze({
  '10': { sigla: 'REPUBLICANOS' },
  '11': { sigla: 'PP' },
  '12': { sigla: 'PDT' },
  '13': { sigla: 'PT' },
  '14': { sigla: 'PTB' },
  '15': { sigla: 'MDB' },
  '16': { sigla: 'PSTU' },
  '17': { sigla: 'PSL' },
  '18': { sigla: 'REDE' },
  '19': { sigla: 'PODE' },
  '20': { sigla: 'PODE' },
  '21': { sigla: 'PCB' },
  '22': { sigla: 'PL' },
  '23': { sigla: 'CIDADANIA' },
  '25': { sigla: 'DEM' },
  '27': { sigla: 'DC' },
  '28': { sigla: 'PRTB' },
  '29': { sigla: 'PCO' },
  '30': { sigla: 'NOVO' },
  '31': { sigla: 'PHS' },
  '33': { sigla: 'MOBILIZA' },
  '35': { sigla: 'PMB' },
  '36': { sigla: 'AGIR' },
  '40': { sigla: 'PSB' },
  '43': { sigla: 'PV' },
  '44': { sigla: 'UNIÃO' },
  '45': { sigla: 'PSDB' },
  '50': { sigla: 'PSOL' },
  '51': { sigla: 'PATRIOTA' },
  '55': { sigla: 'PSD' },
  '65': { sigla: 'PCdoB' },
  '70': { sigla: 'AVANTE' },
  '77': { sigla: 'SOLIDARIEDADE' },
  '80': { sigla: 'UP' },
  '90': { sigla: 'PROS' }
});

export function createInitialPainelState() {
  return {
    dadosCache: {},
    charts: {},
    analisesSalvas: [],
    catalogo: null,
    partidosCatalog: DEFAULT_PARTY_CATALOG,
    municipioAnalise: null,
    zonaAnalise: null,
    comparativo: null,
    comparativoModo: 'candidatos',
    editingAnalysisId: null,
    recorte: null,
  };
}
